"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduxBeacon = require("redux-beacon");

var _googleTagManager = _interopRequireDefault(require("@redux-beacon/google-tag-manager"));

var _types = require("../actions/types");

var eventForTrekPaymentReviewView = function eventForTrekPaymentReviewView(action) {
  return {
    event: 'viewTrekPaymentReview',
    selectedTrekName: action.trekName
  };
};

var eventForNewTrekCreated = function eventForNewTrekCreated(action) {
  return {
    event: 'trekCreationSuccess'
  };
};

var eventForNewSignup = function eventForNewSignup(action) {
  return {
    event: 'signupSuccess',
    formId: 'signup-form'
  };
};

var eventForTrekPaymentSuccess = function eventForTrekPaymentSuccess(action) {
  return {
    event: 'trekPaymentSuccess',
    trekPurchasedRevenue: action.amount,
    paymentType: action.paymentType
  };
};

var eventForLodgeBookingRequestSuccess = function eventForLodgeBookingRequestSuccess(action) {
  return {
    event: 'lodgeBookingRequestSuccess',
    lodgeBookingRequestRevenue: action.amount,
    paymentType: action.paymentType,
    lodgeName: action.lodgeName
  };
};

var eventForSetUserId = function eventForSetUserId(action) {
  return {
    event: 'setUserId',
    userId: action.userId
  };
};

var eventForFlightBookingSuccess = function eventForFlightBookingSuccess(action) {
  return {
    event: 'flightBookingSuccess',
    flightBookingRevenue: action.amount,
    flightBookingType: action.flightType
  };
};

var eventForEmailSubscription = function eventForEmailSubscription() {
  return {
    event: 'emailSubscription'
  };
};

var eventForFlightSearch = function eventForFlightSearch(action) {
  return {
    event: 'flightSearched',
    flight_startdate: action.startDate
  };
}; // ============ EVENTS FOR GUIDES FLOW ===========


var eventForRequestPorterGuide = function eventForRequestPorterGuide() {
  return {
    event: 'requestPorterGuide'
  };
};

var eventForViewGuideProfile = function eventForViewGuideProfile() {
  return {
    event: 'viewGuideProfile'
  };
};

var eventForRequestGuide = function eventForRequestGuide() {
  return {
    event: 'requestGuide'
  };
};

var eventForPorterGuidePaymentSuccess = function eventForPorterGuidePaymentSuccess(action) {
  return {
    event: 'porterGuidePaymentSuccess',
    porterGuideBookingRevenue: action.amount
  };
};

var eventForGuidePaymentSuccess = function eventForGuidePaymentSuccess(action) {
  return {
    event: 'guidePaymentSuccess',
    guideBookingRevenue: action.amount
  };
};

var eventsMapper = function eventsMapper(action) {
  switch (action.type) {
    case _types.SIGNEDUP_SUCCESS:
      return eventForNewSignup;

    case _types.USE_TREK_AS_TEMPLATE_SUCCESS:
      return eventForNewTrekCreated;

    case _types.TREK_PAYMENT_SUCCESS:
      return eventForTrekPaymentSuccess;

    case _types.LODGE_BOOKING_REQUEST_SUCCESS:
      return eventForLodgeBookingRequestSuccess;

    case _types.SET_USER_ID:
      return eventForSetUserId;

    case _types.FLIGHT_BOOKING_SUCCESS:
      return eventForFlightBookingSuccess;

    case _types.TRACK_TREK_PAYMENT_REVIEW_PAGEVIEW:
      return eventForTrekPaymentReviewView;

    case _types.ON_EMAIL_SUBSCRIPTION:
      return eventForEmailSubscription;

    case _types.ON_FLIGHTS_SEARCH:
      return eventForFlightSearch;
    // NEW EVENTS

    case _types.CLICKED_ON_REQUEST_PORTER_GUIDE:
      return eventForRequestPorterGuide;

    case _types.CLICKED_ON_VIEW_GUIDE_PORFILE:
      return eventForViewGuideProfile;

    case _types.CLICKED_ON_REQUEST_GUIDE:
      return eventForRequestGuide;

    case _types.PORTER_GUIDE_PAYMENT_SUCCESS:
      return eventForPorterGuidePaymentSuccess;

    case _types.GUIDE_PAYMENT_SUCCESS:
      return eventForGuidePaymentSuccess;

    default:
      return [];
  }
};

var gtm = (0, _googleTagManager["default"])();

var _default = (0, _reduxBeacon.createMiddleware)(eventsMapper, gtm);

exports["default"] = _default;